import { render, staticRenderFns } from "./AssetRecord.vue?vue&type=template&id=96657340&scoped=true"
import script from "./AssetRecord.vue?vue&type=script&lang=js"
export * from "./AssetRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96657340",
  null
  
)

export default component.exports